import { createContext, useContext } from 'react'

import { WHITE_LABEL_THEMES } from '~lib/constants'

// TODO merge with FEATURES
export const defaultFeatuerFlagsState = {
  key: WHITE_LABEL_THEMES.IGNITION,
  researchHub: true,
  competitiveIntelligence: true,
  productRoadmap: true,
  billing: true,
  renameReleaseNotesAsProjectUpdates: true,
  expiredTrialLimitation: true,
  tasksKanbanView: true,
}

export type FeatureFlagsType = typeof defaultFeatuerFlagsState

// TODO merge with useFeatures and move to backend-side
export const FeatureFlagsContext = createContext(defaultFeatuerFlagsState)

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext)
}
